/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type FavNotifications_favoriteNotificationsTiles = {|
  +tiles: ?$ReadOnlyArray<?{| |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "createdAfter",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "eventsLimit",
      "type": "Int!",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "notificationItemsLimit",
      "type": "Int!",
      "defaultValue": 0
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavNotifications_favoriteNotificationsTiles",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "tiles",
      "args": [
        {
          "kind": "Variable",
          "name": "createdAfter",
          "variableName": "createdAfter",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "notificationItemsLimit",
          "variableName": "notificationItemsLimit",
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "notificationsLimit",
          "variableName": "eventsLimit",
          "type": "Int"
        }
      ],
      "concreteType": "FavoriteNotification",
      "name": "notificationsList",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FavNotificationsTileList_tiles",
          "args": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FavoriteNotifications"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/FavNotifications/__generated__/FavNotifications_favoriteNotificationsTiles.graphql.js